module.exports = __webpack_public_path__ + "static/media/right_attack.05f7431c.png";